export default function applicationTilesStickyHeaders() {
  const headers = document.getElementsByClassName(
    "application-tiles__tile-header",
  );

  const browserWidth = document.body.offsetWidth;
  const matchesNavigation = browserWidth >= 1200;

  // Add class based on other visible UI elements;
  // will adjust sticky positioning
  const headersArr = Array.from(headers);

  const addRemoveScrollClass = () => {
    let globalHeaderVisible;
    // Global header is always visible on mobile, but can disappear
    // on desktop. Check browser size first.
    if (matchesNavigation) {
      globalHeaderVisible = !document
        .querySelector(".global-header")
        .classList.contains("scroll-top");
    } else {
      globalHeaderVisible = true;
    }

    let globalAlertVisible;
    if (matchesNavigation) {
      globalAlertVisible = false;
    } else {
      globalAlertVisible =
        !document
          .querySelector(".global-header")
          .classList.contains("scroll-top") &&
        document.querySelector(".mobile-header__alert");
    }

    const secondaryNav = document.querySelector(".secondary-navigation__mount");

    headersArr.forEach((header) => {
      globalHeaderVisible
        ? header.classList.add("--with-header")
        : header.classList.remove("--with-header");

      globalAlertVisible
        ? header.classList.add("--with-alert")
        : header.classList.remove("--with-alert");

      secondaryNav
        ? header.classList.add("--with-sec-nav")
        : header.classList.remove("--with-sec-nav");
    });
  };

  window.addEventListener("scroll", addRemoveScrollClass);
}
